import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
	selector: '[uiNewLayoutIconTextValue]',
	templateUrl: './icon-text-value.component.html',
	styleUrls: ['./icon-text-value.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	host: {
		class: 'w-100 fl',
	},
})
export class UiNewLayoutIconTextValue {
	@HostBinding('style.--ui-new-layout-icon-text-value-gap')
	protected gapStyle: string | null = null;

	@Input()
	public set gap(value: string | number | null | undefined) {
		if (value == null || value === '') {
			this.gapStyle = null;
			return;
		}

		if (typeof value === 'number') {
			this.gapStyle = `calc(${value} * var(--spacing))`;
			return;
		}

		const spacingMultiplier = Number(value);

		if (!Number.isNaN(spacingMultiplier)) {
			this.gapStyle = `calc(${spacingMultiplier} * var(--spacing))`;
			return;
		}

		this.gapStyle = value;
	}
}
